module.exports = require('./helpers/bundle-url').getBundleURL('7cmdB') + "logo-dark.eefe0b7f.svg";